const EosToastType = Object.freeze({
  info: 'info',
  success: 'success',
  error: 'error',
  warning: 'warning',
  default: 'default'
});

export default EosToastType;